import React from 'react'
import { useTranslation } from 'react-i18next'

interface ErrorFallbackProps {
	error: Error | null
}

const ErrorFallback = ({ error }: ErrorFallbackProps) => {
	const { t } = useTranslation()
	const message = error?.message && String(error.message) ? error.message : t('common.unexpectedError')
	return (
		<div style={{ padding: '20px', textAlign: 'center' }}>
			<h2>{t('common.somethingWentWrong')}</h2>
			<p>{message}</p>
			<button onClick={() => window.location.reload()}>{t('common.reloadPage')}</button>
		</div>
	)
}

export default ErrorFallback
